/**
 * Product Cards - Clean Mobile-First JavaScript
 * Essential functionality only
 */

/* ============================================
   CART COUNTER UPDATE FUNCTION
   ============================================ */
window.updateCartCounter = function () {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble) return;

  const cacheBuster = '?_=' + Date.now();
  fetch('/cart.js' + cacheBuster, {
    method: 'GET',
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache'
    }
  })
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch cart: ' + response.status);
      return response.json();
    })
    .then(cartData => {
      const newCount = cartData.item_count || 0;
      updateCartCounterDisplay(cartIconBubble, newCount);
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
};

function updateCartCounterDisplay(cartIconBubble, newCount) {
  const oldBubble = cartIconBubble.querySelector('.cart-count-bubble');

  if (newCount > 0) {
    if (oldBubble) {
      const countSpan = oldBubble.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = newCount < 100 ? newCount.toString() : '';
      }
    } else {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = newCount < 100 ? newCount.toString() : '';
      bubble.appendChild(span);
      const hiddenSpan = document.createElement('span');
      hiddenSpan.className = 'visually-hidden';
      hiddenSpan.textContent = `${newCount} items in cart`;
      bubble.appendChild(hiddenSpan);
      cartIconBubble.appendChild(bubble);
    }
  } else {
    if (oldBubble) oldBubble.remove();
  }
}

/* ============================================
   ADD TO CART FUNCTION (lean, single request)
   Also manages button text state on the card.
   ============================================ */
function addToCart(variantId, card) {
  if (!variantId) {
    console.warn('Variant ID missing');
    return;
  }

  const addBtn = card ? card.querySelector('.product-card-add-to-cart-btn') : null;

  // Prevent double-submission from the same card
  if (addBtn && addBtn.dataset.adding === 'true') {
    return;
  }

  if (addBtn) {
    addBtn.dataset.adding = 'true';
    if (!addBtn.dataset.originalText) {
      addBtn.dataset.originalText = addBtn.textContent.trim();
    }
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }]
    })
  })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add to cart: ' + response.status);
      return response.json();
    })
    .then(data => {
      if (typeof window.updateCartCounter === 'function') {
        setTimeout(() => {
          window.updateCartCounter();
        }, 300);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

      if (addBtn) {
        addBtn.textContent = 'Added!';
        setTimeout(() => {
          addBtn.textContent = addBtn.dataset.originalText || 'Add to cart';
          addBtn.disabled = false;
          addBtn.dataset.adding = 'false';
        }, 1000);
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      if (addBtn) {
        addBtn.textContent = 'Error';
        setTimeout(() => {
          addBtn.textContent = addBtn.dataset.originalText || 'Add to cart';
          addBtn.disabled = false;
          addBtn.dataset.adding = 'false';
        }, 1500);
      } else {
        alert('Unable to add product to cart. Please try again.');
      }
    });
}

/* ============================================
   IMAGE CAROUSEL FUNCTIONALITY
   ============================================ */
function initImageCarousel(card) {
  const imageContainer = card.querySelector('.product-card-top');
  if (!imageContainer || !imageContainer.classList.contains('has-carousel')) return;

  const images = card.querySelectorAll('.product-card-image');
  const prevBtn = card.querySelector('.product-card-carousel-prev');
  const nextBtn = card.querySelector('.product-card-carousel-next');
  const imageCount = images.length;
  let currentIndex = 0;
  let lockedImageIndex = null;

  if (imageCount <= 1) return;

  images.forEach((img, index) => {
    if (img.classList.contains('active')) {
      currentIndex = parseInt(img.dataset.imageIndex) || index;
    }
  });

  function showImage(index) {
    if (lockedImageIndex !== null && index !== lockedImageIndex) return;

    images.forEach((img, i) => {
      const imgIndex = parseInt(img.dataset.imageIndex) || i;
      if (imgIndex === index) {
        img.classList.add('active');
        img.style.opacity = '1';
        img.style.zIndex = '2';
      } else {
        img.classList.remove('active');
        img.style.opacity = '0';
        img.style.zIndex = '1';
      }
    });
    currentIndex = index;
  }

  function nextImage() {
    if (lockedImageIndex !== null) return;
    const next = (currentIndex + 1) % imageCount;
    showImage(next);
  }

  function prevImage() {
    if (lockedImageIndex !== null) return;
    const prev = (currentIndex - 1 + imageCount) % imageCount;
    showImage(prev);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      prevImage();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      nextImage();
    });
  }

  imageContainer.addEventListener('mouseenter', function () {
    if (lockedImageIndex === null && imageCount > 1) {
      setTimeout(() => {
        if (lockedImageIndex === null) {
          nextImage();
        }
      }, 300);
    }
  });

  imageContainer.addEventListener('mouseleave', function () {
    if (lockedImageIndex !== null) {
      showImage(lockedImageIndex);
    } else {
      showImage(0);
    }
  });

  card._carouselLock = function (imageIndex) {
    lockedImageIndex = imageIndex;
    if (imageIndex !== null) {
      showImage(imageIndex);
    }
  };
}

/* ============================================
   COLOR SWATCH FUNCTIONALITY
   ============================================ */
function initColorSwatches(card) {
  const swatches = card.querySelectorAll('.product-card-swatch');
  if (swatches.length === 0) return;

  let lockedColor = null;
  let lockedImageIndex = null;

  swatches.forEach(function (swatch) {
    const imageIndex = parseInt(swatch.dataset.imageIndex) || 0;
    const colorValue = swatch.dataset.colorValue;

    swatch.addEventListener('mouseenter', function () {
      if (lockedColor === null) {
        if (card._carouselLock) {
          card._carouselLock(imageIndex);
        } else {
          const images = card.querySelectorAll('.product-card-image');
          images.forEach((img, i) => {
            const idx = parseInt(img.dataset.imageIndex) || i;
            if (idx === imageIndex) {
              img.classList.add('active');
              img.style.opacity = '1';
              img.style.zIndex = '2';
            } else {
              img.classList.remove('active');
              img.style.opacity = '0';
              img.style.zIndex = '1';
            }
          });
        }
      }
    });

    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      lockedColor = colorValue;
      lockedImageIndex = imageIndex;

      if (card._carouselLock) {
        card._carouselLock(imageIndex);
      } else {
        const images = card.querySelectorAll('.product-card-image');
        images.forEach((img, i) => {
          const idx = parseInt(img.dataset.imageIndex) || i;
          if (idx === imageIndex) {
            img.classList.add('active');
            img.style.opacity = '1';
            img.style.zIndex = '2';
          } else {
            img.classList.remove('active');
            img.style.opacity = '0';
            img.style.zIndex = '1';
          }
        });
      }

      const modal = card.querySelector('.product-card-size-modal');
      if (modal) {
        const colorNameSpan = modal.querySelector('.size-modal-color-name');
        if (colorNameSpan) {
          colorNameSpan.textContent = colorValue;
        }
      }
    });
  });

  card._getLockedColor = function () {
    return lockedColor;
  };
}

/* ============================================
   INITIALIZATION
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-card-interactive');

  productCards.forEach(function (card) {
    initImageCarousel(card);
    initColorSwatches(card);

    const addToCartBarBtn = card.querySelector('.product-card-add-to-cart-btn');
    const sizeModal = card.querySelector('.product-card-size-modal');
    const productId = card.dataset.productId;
    let selectedVariantId = addToCartBarBtn?.dataset.variantId;

    /* Size Selection Modal */
    if (sizeModal && addToCartBarBtn?.dataset.hasSizes === 'true') {
      const sizeOptions = sizeModal.querySelectorAll('.size-option-btn');
      const addToCartBtn = sizeModal.querySelector('.size-modal-add-btn');
      const closeBtn = sizeModal.querySelector('.size-modal-close');
      const overlay = sizeModal.querySelector('.size-modal-overlay');
      const colorNameSpan = sizeModal.querySelector('.size-modal-color-name');

      function updateModalColor() {
        const lockedColor = card._getLockedColor ? card._getLockedColor() : null;
        if (colorNameSpan) {
          if (lockedColor) {
            colorNameSpan.textContent = lockedColor;
            colorNameSpan.style.display = 'inline';
          } else {
            colorNameSpan.textContent = '';
            colorNameSpan.style.display = 'none';
          }
        }
      }

      sizeOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          sizeOptions.forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedVariantId = btn.dataset.variantId;
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
          }
        });
      });

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          if (!selectedVariantId) return;
          addToCart(selectedVariantId, card);
          sizeModal.classList.remove('active');
          document.body.style.overflow = '';
        });
      }

      function closeModal() {
        sizeModal.classList.remove('active');
        document.body.style.overflow = '';
        sizeOptions.forEach(b => b.classList.remove('selected'));
        if (addToCartBtn) addToCartBtn.disabled = true;
        selectedVariantId = addToCartBarBtn?.dataset.variantId;
      }

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', closeModal);

      const modalContent = sizeModal.querySelector('.size-modal-content');
      if (modalContent) {
        modalContent.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }

      card._updateModalColor = updateModalColor;
    }

    /* Add to Cart */
    if (addToCartBarBtn) {
      addToCartBarBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!productId) {
          console.warn('Product ID missing');
          return;
        }

        if (addToCartBarBtn.dataset.hasSizes === 'true' && sizeModal) {
          if (card._updateModalColor) card._updateModalColor();
          sizeModal.classList.add('active');
          document.body.style.overflow = 'hidden';
          return;
        }

        if (selectedVariantId) {
          addToCart(selectedVariantId, card);
        } else {
          const productLink = card.querySelector('.product-card-title a');
          if (productLink) {
            window.location.href = productLink.href;
          }
        }
      });
    }

    /* Prevent card click when clicking interactive elements */
    const interactiveElements = card.querySelectorAll(
      '.product-card-add-to-cart-btn, .product-card-title a, .size-modal-content, .product-card-carousel-arrow, .product-card-swatch'
    );

    interactiveElements.forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  });
});

/* ============================================
   WISHLIST FUNCTIONALITY (Event Delegation)
   ============================================ */
/* 
   WISHLIST LOGIC HAS BEEN MOVED TO wishlist-system.js
   TO PREVENT CONFLICTS AND ENSURE PERSISTENCE.
   DO NOT UNCOMMENT.
*/
/*
document.addEventListener('DOMContentLoaded', function () {
  const WISHLIST_KEY = 'illtochill_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      console.error('Error parsing wishlist:', e);
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    // Dispatch event so other components can update if needed
    window.dispatchEvent(new CustomEvent('illtochill:wishlist-updated', { detail: { items } }));
  }

  function toggleWishlistItem(handle) {
    const items = getWishlist();
    const index = items.indexOf(handle);
    let isAdded = false;

    if (index === -1) {
      items.push(handle);
      isAdded = true;
    } else {
      items.splice(index, 1);
      isAdded = false;
    }

    saveWishlist(items);
    return isAdded;
  }

  // 1. Initialize Active State on Load
  function initWishlistState() {
    const wishlistBtns = document.querySelectorAll('.product-card-wishlist-btn');
    const currentWishlist = getWishlist();

    wishlistBtns.forEach(btn => {
      const handle = btn.dataset.productHandle;
      const svg = btn.querySelector('svg');

      if (handle && currentWishlist.includes(handle)) {
        btn.classList.add('active');
        if (svg) {
          svg.style.fill = '#B90404';
          svg.style.stroke = '#B90404';
        }
      } else {
        btn.classList.remove('active');
        if (svg) {
          svg.style.fill = 'none';
          svg.style.stroke = 'currentColor';
        }
      }
    });
  }

  // 2. Click Handler (Delegated)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-card-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.productHandle;
    if (!handle) {
      console.warn('Wishlist button missing data-product-handle');
      return;
    }

    // TOGGLE UI IMMEDIATELY
    const isActive = btn.classList.contains('active');
    const svg = btn.querySelector('svg');

    if (!isActive) {
      btn.classList.add('active');
      if (svg) {
        svg.style.fill = '#B90404';
        svg.style.stroke = '#B90404';
      }
    } else {
      btn.classList.remove('active');
      if (svg) {
        svg.style.fill = 'none';
        svg.style.stroke = 'currentColor';
      }
    }

    // UPDATE STORAGE
    toggleWishlistItem(handle);
  });

  // Run initialization
  initWishlistState();

  // Re-run initialization if wishlist updates elsewhere (e.g. separate tab or component)
  window.addEventListener('illtochill:wishlist-updated', function (e) {
    initWishlistState();
  });
});
*/
